import './lpiSchedule.css';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, NavItem, Table } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/Search";
import DatePicker from "react-datepicker";
import { authKey, GET_STAKEHOLDER_CATEGORY, APPROVE_WEEKLY_SCHEDULE, GET_SCHEDULE_APPROVAL_LIST } from '../../../common/URLs';

import jwt from 'jwt-decode';
import { DataGrid } from '@mui/x-data-grid';
import { Button, Box, Card, IconButton, MenuItem, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab, CardContent } from '@mui/material'
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import moment from 'moment';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { PROD, PIT_ROLES } from '../../../common/constants';
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import { ConfirmPopover } from "../../../preregcamps/confirmPopover/confirmPopover";
import { toast } from 'react-toastify';
import { userData } from '../../../common/spinLoader';
import { useTranslation } from "react-i18next";
import apiClient from '../../../axios';

function WeeklyScheduleApprovalList() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const userLoggedInRole = userData?.user?.userRoles?.[0]?.roleName;
    const decoded = jwt(getLocalStorageItem('id_token'));
    const [lpischeduleno, setLpischeduleno] = useState([]);
    const [lpiweeklyscheduledata, setLpiweeklyscheduledata] = useState();
    const [weeklyscheduledata, setweeklyscheduledata] = useState([]);
    const [lpiVisible, setLpiVisible] = useState();
    const [stakeholderDetails, setStakeholderDetails] = useState();
    const [tabValue, setTabValue] = React.useState("");
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date(fromDate.getTime() + 7 * 24 * 60 * 60 * 1000));
    const [searchVisible, setSearchvisible] = useState(false);
    const [selectedRows, setSelectedRows] = useState();
    const [approveButtonData, setApproveButtonData] = useState();
    const [approveDataList, setApproveDataList] = useState();

    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const [logModalOpen2, setLogModalOpen2] = useState(false);
    const handleLogModalOpen2 = () => setLogModalOpen2(true);
    const handleLogModalClose2 = () => setLogModalOpen2(false);



    useEffect(() => {
        // if (decoded.extension_URN) {
        if (userLoggedInRole && userLoggedInRole === PIT_ROLES.ProcessingIncharge) {
            getWeeklySchduleApproval("Chipping");
            setTabValue("Chipping")
        } else if (userLoggedInRole && userLoggedInRole === PIT_ROLES.TransportationIncharge) {
            getWeeklySchduleApproval("Pending");
            setTabValue("Pending")
        }

        getStakeDetails();
        // }
    }, [decoded.extension_URN]);

    function getStakeDetails() {
        apiClient
            .post(GET_STAKEHOLDER_CATEGORY,
                {
                    "urn": decoded.extension_URN,
                    "type": ""
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setStakeholderDetails(response.data);
            })
            .catch(function (error) {
                console.log(error);
                toast.error(error.message);
            });
    }




    useEffect(() => {
        if (stakeholderDetails) {
            // getLpiScheduleNo();
        }
    }, [stakeholderDetails]);


    const getWeeklySchduleApproval = (tabVal) => {

        loaderService.showLoader()
        apiClient
            .post(GET_SCHEDULE_APPROVAL_LIST,
                {
                    "type": tabVal,
                    "roleType": "Processing"
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                console.log(response);
                setweeklyscheduledata(response.data.weeklySchedulePlanDetailsList)
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });

    }





    const columns = [
        { field: 'weeklyScheduleNumber', headerName: 'Schedule No', width: 280 },
        { field: 'scheduleLineNumber', headerName: 'Schedule Line No', width: 200 },
        {
            field: 'schedulePickupDate', headerName: t('reg.date'), width: 220,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        { field: 'scheduleRbCbQuantity', headerName: 'Quantity for Chipping', width: 200 },
        {
            field: 'isScheduledApproved', headerName: 'Approval Status', width: 150,
            valueFormatter: (params) => {
                if (params.value === true) {
                    return 'Approved';
                }
                else if (params.value === false) {
                    return 'Rejected';
                }
                else {
                    return 'Not Approved';
                }
            },
            getCellValue: (params) => {
                if (params?.row?.scheduleStakeholderType === stakeholderDetails?.category) {
                    return <>{params?.row?.isScheduledApproved}</>;
                } else if (params?.row?.firstPartyType === stakeholderDetails?.category) {
                    return <>{params?.row?.isFirstPartyApproved}</>;
                } else {
                    return <>{params?.row?.isSecondPartyApproved}</>;
                }
            },
        },
    ];

    const columns2 = [
        { field: 'weeklyScheduleNumber', headerName: 'Schedule No', width: 250 },
        { field: 'scheduleLineNumber', headerName: 'Schedule Line No', width: 150 },
        {
            field: 'schedulePickupDate', headerName: 'Pick up Date', width: 150,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        { field: 'scheduleRbCbQuantity', headerName: 'Quantity', width: 150 },
        {
            field: 'stakeholderUrn', headerName: 'URN(1stParty)', width: 150, hide: (tabValue === "Unloading" && stakeholderDetails?.category === "LLE"),
            renderCell: (cellValues) => {
                return (
                    tabValue === "Loading" ?
                        <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderUrn : cellValues?.row?.firstPartyUrn}</>
                        :
                        <> {cellValues?.row?.firstPartyUrn} </>
                );
            }
        },
        {
            field: 'stakeholderContactNo', headerName: 'Contact Details(1stParty)', width: 150, hide: (tabValue === "Unloading" && stakeholderDetails?.category === "LLE"),
            renderCell: (cellValues) => {
                return (
                    tabValue === "Loading" ?
                        <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderContactNo : cellValues?.row?.firstPartyContactNo}</>
                        :
                        <> {cellValues?.row?.firstPartyContactNo} </>
                );
            }
        },
        {
            field: 'stakeholderLocationName', headerName: 'Location(1stParty)', width: 150, hide: (tabValue === "Unloading" && stakeholderDetails?.category === "LLE"), renderCell: (cellValues) => {
                return (
                    tabValue === "Loading" ?
                        <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderLocationName : cellValues?.row?.firstPartyLocationName}</>
                        :
                        <> {cellValues?.row?.firstPartyLocationName} </>
                );
            }
        },
        {
            field: 'secondPartyUrn', headerName: 'URN(2ndParty)', width: 150,
            renderCell: (cellValues) => {
                return (
                    tabValue === "Unloading" ?
                        <>{cellValues?.row?.secondPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderUrn : cellValues?.row?.secondPartyUrn}</>
                        :
                        <> {cellValues?.row?.secondPartyUrn} </>
                );
            }
        },
        {
            field: 'secondPartyContactNo', headerName: 'Contact Details(2ndParty)', width: 150,
            renderCell: (cellValues) => {
                return (
                    tabValue === "Unloading" ?
                        <>{cellValues?.row?.secondPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderContactNo : cellValues?.row?.secondPartyContactNo}</>
                        :
                        <> {cellValues?.row?.secondPartyContactNo} </>
                );
            }
        },
        {
            field: 'secondPartyLocationName', headerName: 'Location(2ndParty)', width: 150,
            renderCell: (cellValues) => {
                return (
                    tabValue === "Unloading" ?
                        <>{cellValues?.row?.secondPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderLocationName : cellValues?.row?.secondPartyLocationName}</>
                        :
                        <> {cellValues?.row?.secondPartyLocationName} </>
                );
            }
        },
        {
            field: 'scheduledDeliveryDate', headerName: 'Delivery Date', width: 150,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY")
        },
        { field: 'poStpoNumber', headerName: 'PO Number', width: 150 },
        { field: 'inventoryType', headerName: 'Type of Inventory', width: 150 },
        {
            field: 'isScheduledApproved', headerName: 'Approval Status', width: 150,
            valueFormatter: (params) => {
                if (params.value === true) {
                    return 'Approved';
                }
                else if (params.value === false) {
                    return 'Rejected';
                }
                else {
                    return 'Not Approved';
                }
            },
            getCellValue: (params) => {
                if (params?.row?.scheduleStakeholderType === stakeholderDetails?.category) {
                    return <>{params?.row?.isScheduledApproved}</>;
                } else if (params?.row?.firstPartyType === stakeholderDetails?.category) {
                    return <>{params?.row?.isFirstPartyApproved}</>;
                } else {
                    return <>{params?.row?.isSecondPartyApproved}</>;
                }
            },
        },
        // { field: '', headerName: 'Action', width: 100 },
        {
            field: 'Navigate', headerName: 'Navigate', width: 200, hide: stakeholderDetails?.category != "HIT",
            renderCell: (cellValues) => {
                return (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => harvestingDetails(cellValues)}
                    >
                        Harvesting Details
                    </Button>
                );
            }
        },
        {
            field: 'Print', headerName: "Print", width: 200, hide: stakeholderDetails?.category != "HIT",
            renderCell: () => {
                return (
                    <Button
                        variant="contained"
                        color="primary"
                    >
                        Print
                    </Button>
                );
            }
        }
    ];

    const columns3 = [
        { field: 'weeklyScheduleNumber', headerName: 'Schedule No', width: 250 },
        { field: 'scheduleLineNumber', headerName: 'Schedule Line No', width: 150 },
        {
            field: 'schedulePickupDate', headerName: 'Pick up Date', width: 150,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        { field: 'scheduleRbCbQuantity', headerName: 'Quantity', width: 150 },
        {
            field: 'stakeholderUrn', headerName: 'URN(1stParty)', width: 150, hide: (tabValue === "Unloading" && stakeholderDetails?.category === "LLE"),
            renderCell: (cellValues) => {
                return (
                    tabValue === "Loading" ?
                        <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderUrn : cellValues?.row?.firstPartyUrn}</>
                        :
                        <> {cellValues?.row?.firstPartyUrn} </>
                );
            }
        },
        {
            field: 'stakeholderContactNo', headerName: 'Contact Details(1stParty)', width: 150, hide: (tabValue === "Unloading" && stakeholderDetails?.category === "LLE"),
            renderCell: (cellValues) => {
                return (
                    tabValue === "Loading" ?
                        <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderContactNo : cellValues?.row?.firstPartyContactNo}</>
                        :
                        <> {cellValues?.row?.firstPartyContactNo} </>
                );
            }
        },
        {
            field: 'stakeholderLocationName', headerName: 'Location(1stParty)', width: 150, hide: (tabValue === "Unloading" && stakeholderDetails?.category === "LLE"), renderCell: (cellValues) => {
                return (
                    tabValue === "Loading" ?
                        <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderLocationName : cellValues?.row?.firstPartyLocationName}</>
                        :
                        <> {cellValues?.row?.firstPartyLocationName} </>
                );
            }
        },
        {
            field: 'secondPartyUrn', headerName: 'URN(2ndParty)', width: 150,
            renderCell: (cellValues) => {
                return (
                    tabValue === "Unloading" ?
                        <>{cellValues?.row?.secondPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderUrn : cellValues?.row?.secondPartyUrn}</>
                        :
                        <> {cellValues?.row?.secondPartyUrn} </>
                );
            }
        },
        {
            field: 'secondPartyContactNo', headerName: 'Contact Details(2ndParty)', width: 150,
            renderCell: (cellValues) => {
                return (
                    tabValue === "Unloading" ?
                        <>{cellValues?.row?.secondPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderContactNo : cellValues?.row?.secondPartyContactNo}</>
                        :
                        <> {cellValues?.row?.secondPartyContactNo} </>
                );
            }
        },
        {
            field: 'secondPartyLocationName', headerName: 'Location(2ndParty)', width: 150,
            renderCell: (cellValues) => {
                return (
                    tabValue === "Unloading" ?
                        <>{cellValues?.row?.secondPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderLocationName : cellValues?.row?.secondPartyLocationName}</>
                        :
                        <> {cellValues?.row?.secondPartyLocationName} </>
                );
            }
        },
        {
            field: 'scheduledDeliveryDate', headerName: 'Delivery Date', width: 150,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY")
        },
        { field: 'poStpoNumber', headerName: 'PO Number', width: 150 },
        { field: 'inventoryType', headerName: 'Type of Inventory', width: 150 },
        {
            field: 'isScheduledApproved', headerName: 'Approval Status', width: 150,
            valueFormatter: (params) => {
                if (params.value === true) {
                    return 'Approved';
                }
                else if (params.value === false) {
                    return 'Rejected';
                }
                else {
                    return '';
                }
            },
            getCellValue: (params) => {
                if (params?.row?.scheduleStakeholderType === stakeholderDetails?.category) {
                    return <>{params?.row?.isScheduledApproved}</>;
                } else if (params?.row?.firstPartyType === stakeholderDetails?.category) {
                    return <>{params?.row?.isFirstPartyApproved}</>;
                } else {
                    return <>{params?.row?.isSecondPartyApproved}</>;
                }
            },
        },
        // { field: '', headerName: 'Action', width: 100 },
        {
            field: 'Navigate', headerName: 'Navigate', width: 200, hide: stakeholderDetails?.category != "HIT",
            renderCell: (cellValues) => {
                return (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => harvestingDetails(cellValues)}
                    >
                        Harvesting Details
                    </Button>
                );
            }
        },
        {
            field: 'Print', headerName: "Print", width: 200, hide: stakeholderDetails?.category != "HIT",
            renderCell: () => {
                return (
                    <Button
                        variant="contained"
                        color="primary"
                    >
                        Print
                    </Button>
                );
            }
        }
    ];

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        getWeeklySchduleApproval(newValue);

    };
    const harvestingDetails = (cellValues) => {
        navigate('./harvestingDetails', {
            state: cellValues
        });
    }


    const onApproveButtonClick = (approval) => {
        //loaderService.showLoader();
        console.log(selectedRows);
        let selectedRequestIds = [];
        selectedRows.forEach(selectedRow => {
            selectedRequestIds.push(selectedRow.id);
        });
        let data = {
            "schedule_Id": selectedRequestIds,
            "scheduleApprovalComment": "",
            "roleType": "Processing"
        }

        apiClient
            .post(
                APPROVE_WEEKLY_SCHEDULE,
                data,
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token')
                    }
                },
                null
            )
            .then((response) => {
                setApproveButtonData(response.data);
                getWeeklySchduleApproval(tabValue);
                // console.log(approveButtonData);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                // console.log(approveButtonData);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    useEffect(() => {
        if (approveButtonData) {
            if (approveButtonData.isSuccess === true) {
                toast.success(approveButtonData?.message)
                // handleLogModalOpen2();
            } else {
                toast.error(approveButtonData?.message ? approveButtonData?.message : "Error")
                // handleLogModalOpen();
            }
        }
    }, [approveButtonData]);

    const onApprove = (e) => {
        onApproveButtonClick(true);
    }

    const onReject = (e) => {
        onApproveButtonClick(false);
    }

    return (
        <>
            <Container fluid>
                <Row>
                    {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT47</p>}
                    <div>
                        <form>
                            <div className='headingStylePIT'>weekly schedule approval list</div>
                            <Card>
                                <TabContext value={tabValue} style={{ marginLeft: "1.5vh" }}>
                                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                        <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                                            {userLoggedInRole === PIT_ROLES.ProcessingIncharge && <Tab label="Chipping" value="Chipping" />}
                                            {userLoggedInRole === PIT_ROLES.TransportationIncharge &&
                                            
                                                    <Tab label="Pending" value="Pending" />
                                              
                                            }
                                             {userLoggedInRole === PIT_ROLES.TransportationIncharge &&
                                               
                                                    <Tab label="Approve" value="Approve" />
                                            
                                            }
                                        </TabList>
                                    </Box>
                                    <TabPanel value="Chipping" >

                                        <Card>
                                            <Box style={{ height: 400, width: '100%' }}>
                                                {
                                                    weeklyscheduledata &&
                                                    <DataGrid rows={weeklyscheduledata}
                                                        columns={columns}
                                                        pageSize={5}
                                                        // initialState={{
                                                        //   filter: {
                                                        //     filterModel: {
                                                        //       items: [{ columnField: 'weeklyScheduleNumber', operatorValue: 'equals', value: "Invoice Generated" }],
                                                        //     },
                                                        //   },
                                                        // }}
                                                        components={{ Toolbar: QuickSearchToolbar }}
                                                        checkboxSelection
                                                        onSelectionModelChange={(ids) => {
                                                            console.log("in row selected");
                                                            const selectedIDs = new Set(ids);
                                                            const selectedRowData = weeklyscheduledata?.filter((row) =>
                                                                selectedIDs.has(row.id.toString())
                                                            )
                                                            setSelectedRows(selectedRowData);
                                                        }}

                                                        isRowSelectable={(params) => !((params.row.isScheduledApproved === true || params.row.isScheduledApproved === false) || (params.row.isFirstPartyApproved === true || params.row.isFirstPartyApproved === false) || (params.row.isSecondPartyApproved === true || params.row.isSecondPartyApproved === false))}
                                                    />
                                                }

                                            </Box>
                                        </Card>
                                    </TabPanel>
                                    <TabPanel value="Pending">

                                        <Card>
                                            <Box style={{ height: 400, width: '100%' }}>
                                                {
                                                    weeklyscheduledata &&
                                                    <DataGrid rows={weeklyscheduledata}
                                                        columns={columns2}
                                                        pageSize={5}
                                                        components={{ Toolbar: QuickSearchToolbar }}
                                                        checkboxSelection
                                                        onSelectionModelChange={(ids) => {
                                                            console.log("in row selected");
                                                            const selectedIDs = new Set(ids);
                                                            const selectedRowData = lpiweeklyscheduledata?.filter((row) =>
                                                                selectedIDs.has(row.id.toString())
                                                            )
                                                            setSelectedRows(selectedRowData);
                                                        }}
                                                        isRowSelectable={(params) => !((params.row.isScheduledApproved === true) || (params.row.isFirstPartyApproved === true) || (params.row.isSecondPartyApproved === true))}
                                                    />
                                                }

                                            </Box>
                                        </Card>
                                    </TabPanel>
                                    <TabPanel value="Approve">

                                        <Card>
                                            <Box style={{ height: 400, width: '100%' }}>
                                                {
                                                    weeklyscheduledata &&
                                                    <DataGrid rows={weeklyscheduledata}
                                                        columns={columns3}
                                                        pageSize={5}
                                                        components={{ Toolbar: QuickSearchToolbar }}
                                                    />
                                                }

                                            </Box>

                                        </Card>
                                    </TabPanel>
                                </TabContext>
                            </Card>
                            {weeklyscheduledata?.length > 0 &&
                                <div className='approveRejectBtnDiv'>
                                    <button className="reject-btn-schedule" type="submit" onClick={(e) => onReject(e)}>Reject</button>
                                    <button className="approve-btn-schedule" type="submit" onClick={(e) => onApprove(e)}>Approve</button>
                                </div>
                            }
                        </form>
                    </div>

                </Row>

            </Container>
            <Dialog maxWidth='xs' fullWidth open={logModalOpen2}>
                <DialogContent>
                    <ConfirmPopover title={approveButtonData?.message ? approveButtonData?.message : "Error"} hideLink={true} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleLogModalClose2}>OK</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default WeeklyScheduleApprovalList;